import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};
let highlightsSwiper;

const domCache = () => {
    $DOM.container = $(".highlights-carousel");
    if(!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".highlights-carousel-swiper-container");
}

const initSwiper = () => {
    highlightsSwiper = new Swiper($DOM.swiperContainer[0], {
        modules: [Navigation, Pagination, A11y, Keyboard],
        init: false,
        slidesPerView: 1.2,
        // spaceBetween: 20,
        speed: 750,
        preventClicksPropagation: false,
        roundLengths: true,
        freeMode: true,
        freeModeMomentumBounce: false,
        freeModeMomentumRatio: .1,
        freeModeMomentumVelocityRatio: .8,
        freeModeSticky: true,
        grabCursor: true,
        a11y: true,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        watchOverflow: true,
        breakpoints: {
            576: {
                slidesPerView: 2.5
            },
            769: {
                slidesPerView: 3.5,
            },
            1024 : {
                slidesPerView: 4.5,
            },
            1280 : {
                slidesPerView: 5,
            }
        }
    });

    highlightsSwiper.on("init", onInit);
    highlightsSwiper.init();
}

const onInit = () => {
    $DOM.swiperContainer.addClass("is-init");
}

const highlightsCarousel = {
    init: () => {
        domCache();
        if(!$DOM.container.length) {
            return;
        }
        initSwiper();
    }
};

export default highlightsCarousel;
